import "./App.css";
import "./style.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing/Landing";
import Institution from "./pages/Institution/Institution";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Market from "./pages/Market";
import ContactUs from "./pages/Contact/ContactUs";
import ScrollToTop from "./pages/ScrollToTop";
import Swap from "./pages/Swap";
import MarketDetails from "./pages/MarketDetails";
import SecondaryMarket from "./pages/Secondarymarket";
import { Toaster } from "react-hot-toast";
import "./pages/web3Modal"; // Import Web3Modal config first

import Stake from "./pages/Stake/Stake";
import StakeDetails from "./pages/Stake/StakeDetails";
import LiquidityPool from "./pages/LiquidityPool/LiquidityPool";
import Login from "./pages/Admin/Login/Login";
import AdminDashboard from "./pages/Admin/Dashboard";
import UserManagement from "./pages/Admin/UserManagement";
import IssuerManagement from "./pages/Admin/IssuerManagement";
import ContactManagement from "./pages/Admin/ContactManagement";
import Issuers from "./pages/Admin/Issuers";
import TokenManagement from "./pages/Admin/TokenManagement";
import IssuersDetails from "./pages/Admin/IssuersDetails";
import Portfolio from "./pages/Portfolio";
import Tokenization from "./pages/Admin/Tokenization";
// import Tokenization2 from "./pages/Admin/token2";
import { ToastContainer, toast } from "react-toastify";
import {
  removeAuthToken,
  removeAuthTokenUser,
} from "../src/core/lib/localStorage";
import LiquidityDetails from "./pages/LiquidityPool/LiquidityDetails";
import AddLiquidity from "./pages/LiquidityPool/AddLiquidity";
import AboutUs from "./pages/Aboutus/AboutUs";
import SecondMarketDetails from "./pages/Secondarymarketdetails";

function App() {
  function RequireAuth({ children }) {
    var data = localStorage.getItem("user_token");
    return data ? children : removeAuthToken();
  }

  function RequireAuthUser({ children }) {
    var data = localStorage.getItem("userAddress");
    return data ? children : removeAuthTokenUser();
  }
  return (
    <>
      <BrowserRouter>
        <ToastContainer />
        <ScrollToTop />
        <Toaster position="top-right" reverseOrder={false} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/institution" element={<Institution />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuthUser>
                <Dashboard />
              </RequireAuthUser>
            }
          />
          <Route
            path="/profile"
            element={
              <RequireAuthUser>
                <Profile />
              </RequireAuthUser>
            }
          />
          <Route
            path="/market"
            element={
              <RequireAuthUser>
                <Market />
              </RequireAuthUser>
            }
          />
          <Route path="/contact" element={<ContactUs />} />
          <Route
            path="/swap"
            element={
              <RequireAuthUser>
                <Swap />
              </RequireAuthUser>
            }
          />
          <Route
            path="/secondarymarket"
            element={
              <RequireAuthUser>
                <SecondaryMarket />
              </RequireAuthUser>
            }
          />
          <Route
            path="/marketDetails/:id"
            element={
              <RequireAuthUser>
                <MarketDetails />
              </RequireAuthUser>
            }
          />
          <Route
            path="/secondmarketdetails/:id"
            element={
              <RequireAuthUser>
                <SecondMarketDetails />
              </RequireAuthUser>
            }
          />
          <Route
            path="/stake"
            element={
              <RequireAuthUser>
                <Stake />
              </RequireAuthUser>
            }
          />
          <Route
            path="/portfolio"
            element={
              <RequireAuthUser>
                <Portfolio />
              </RequireAuthUser>
            }
          />
          <Route
            path="/stake-details"
            element={
              <RequireAuthUser>
                <StakeDetails />
              </RequireAuthUser>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/userManagement"
            element={
              <RequireAuth>
                <UserManagement />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/issuermanagement"
            element={
              <RequireAuth>
                <IssuerManagement />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/contactmanagement"
            element={
              <RequireAuth>
                <ContactManagement />
              </RequireAuth>
            }
          />

          <Route
            path="/admin/issuers"
            element={
              <RequireAuth>
                <Issuers />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/tokenmanagement"
            element={
              <RequireAuth>
                <TokenManagement />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/issuersDetails"
            element={
              <RequireAuth>
                <IssuersDetails />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/tokenization"
            element={
              <RequireAuth>
                <Tokenization />
              </RequireAuth>
            }
          />
          {/* <Route path="/admin/tokenization2" element={<Tokenization2 />} /> */}
          {/* <Route path="/liquidity-pool" element={<LiquidityPool />} /> */}
          {/* <Route path="/liquidity-details" element={<LiquidityDetails />} /> */}
          {/* <Route path="/addliquidity" element={<AddLiquidity />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
